/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { selectMixin }    from 'mixins';
import { getUniqueDomId } from 'utils/getUniqueDomId';

const Input              = require('gui/inputs/input');

const __vue_script__ = {

  /** @since 3.8.6 */
  name: "input-unique",

  mixins: [ Input, selectMixin ],
  data() {
    return { id : `unique_${getUniqueDomId()}`}
  },
  async mounted() {
    await this.$nextTick();
    this.select2 = $(`#${this.id}`).select2({
      dropdownParent: $('#g3w-view-content'),
      tags: this.state.input.options.editable,
      language: this.getLanguage()
    });
    if (null !== this.state.value) {
      this.select2.val(this.state.value).trigger('change');
    }
    this.select2.on('select2:select', async e => {
      const value = e.params.data.$value ? e.params.data.$value : e.params.data.id;
      this.state.value = 'null' === value ? null :
        //need to check if values are Number or string  and convert it to compare
        //@TODO need to find a better way to comprare input value (from input html element) value is set as string
        ['integer', 'float', 'bigint'].includes(this.state.type) ? Number(value) : value;
      //check if start value is changed
      this.changeSelect(this.state.value);
      await this.$nextTick();
    })
  },

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseinput',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"}],attrs:{"state":_vm.state}},[_c('select',{staticClass:"form-control",staticStyle:{"width":"100%"},attrs:{"slot":"body","id":_vm.id,"tabIndex":_vm.tabIndex},slot:"body"},[_c('option',{attrs:{"value":"null"}}),_vm._v(" "),_vm._l((_vm.state.input.options.values),function(value){return _c('option',{key:value,domProps:{"value":_vm.getValue(value)}},[_vm._v(_vm._s(_vm.getValue(value)))])})],2)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "InputUnique.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__